var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-block text-center"},[_c('p',{staticClass:"my-4"},[_vm._v("This is the first modal.")]),_c('b-button',{on:{"click":function($event){return _vm.redirectToModal('secondModal')}}},[_vm._v("Go to Second Modal")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }